module.exports = __webpack_public_path__ + "img/scsk.7ec9f9f4.png";